import React, {FC, useRef} from 'react';
import {useLocation} from 'react-router';
import {NavLink, useNavigate} from 'react-router';
import AddBoxOutlinedIcon from '@mui/icons-material/AddBoxOutlined';
import {Typography, useTheme} from '@mui/material';
import {activityLogRoute, adminRoute, dashboardRoute,} from 'src/routes';
import {navigationItemMinWidth, useDashboardLayoutHeaderNavigationStyles} from 'src/components/MainLayout/styles';
import {isSecurityPostureRoute} from "./SecurityPostureMenu";

// The isSecurityPostureRoute functions, below, help show the
// correct state of the navigation items.  The NavLink isActive
// mechanism doesn't seem sufficient
const allNavigationItems = [
  {
    url: dashboardRoute,
    label: 'Security Posture',
    isSecurityPosture: isSecurityPostureRoute,
  },
  {
    url: activityLogRoute,
    // label: `${capitalizeFirstLetter(wordForChange)} Log`,
    label: `Activity Log`,
    isSecurityPosture: () => false,
  },
];

export const addSaasMenuButtonId = 'add-saas-menu-button';

export const Navigation: FC = () => {
  const {pathname} = useLocation();
  const navigate = useNavigate();

  const theme = useTheme();
  const { classes: {
    navigationContainer,
    navigationMenu,
    navigationItem,
    navigationItemLink,
    navigationItemLinkActive,
    navigationAddSaaS,
  } } = useDashboardLayoutHeaderNavigationStyles();

  let navAddSaasRef = useRef(null);

  const handleshowAddSaasListClick = (
    event: React.MouseEvent<HTMLElement>
  ) => {
    // if(process.env.PASSGENAU_FEATURE_FLAG_ADMIN === '1')
      navigate(adminRoute);
    // else
    //   setIsSaasListPopperOpen(!isSaasListPopperOpen);
  };

  return (
  <div
    ref={navAddSaasRef}
    className={navigationContainer}>
    <div
      className={navigationAddSaaS}
      onClick={handleshowAddSaasListClick}
    >
      <div id={addSaasMenuButtonId}>
        <AddBoxOutlinedIcon
          sx={{
            color: theme.palette.primary.main,
          }}
        />
        <Typography component="span">Add SaaS</Typography>
      </div>
    </div>
    <ul className={navigationMenu} data-testid="navigation-items-list">
      {
        allNavigationItems.map(({url, label, isSecurityPosture}) => (
          <li className={navigationItem} key={url}>
            <NavLink
              style={{
                minWidth: navigationItemMinWidth,
              }}
              // this id is part of an experiment to do first click
              // on the Security Posture button when the menu is open
              id={
                isSecurityPostureRoute(url) ?
                  'posture-buton' :
                  'activity-button'
              }
              data-testid={`nav-item-${label}`}
              className={
                // See notes above describing the isSecurityPosture()
                // function. The issue was that isActive isn't sufficient.
                ({isActive }) =>
                  isActive || isSecurityPosture(pathname) ?
                    navigationItemLinkActive :
                    navigationItemLink
              }
              to={url}
              title={label}
            >
              {label}
            </NavLink>
          </li>
        ))
      }
    </ul>
  </div>
);

};
